import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '@mui/material/styles';
import { RetailerHeaderModel } from '../../../../app/services/api/ofdClient';

interface RetailersByOnboardingStatusProps {
  retailers: RetailerHeaderModel[];
}

const RetailersByOnboardingStatus = ({ retailers }: RetailersByOnboardingStatusProps) => {
  const theme = useTheme();

  // Example: statusId 3 = Onboarded, 2 = In Progress, 1 = Not Started (adjust as needed)
  const statusCounts = {
    Onboarded: 0,
    InProgress: 0,
  };
  retailers.forEach(r => {
    if (r.statusId === 2) {
      statusCounts.Onboarded++;
    } else if (r.statusId === 1) {
      statusCounts.InProgress++;
    }
  });

  const data = [
    { name: 'Onboarded', value: statusCounts.Onboarded },
    { name: 'In Progress', value: statusCounts.InProgress },
  ];

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28'];

  // Custom label renderer to prevent truncation
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: { cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.1;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const name = data[index].name;
    return (
      <text
        x={x}
        y={y}
        fill={theme.palette.text.primary}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{ fontSize: theme.typography.textSM?.fontSize || 12, fontFamily: theme.typography.fontFamily }}
      >
        {`${name} (${(percent * 100).toFixed(0)}%)`}
      </text>
    );
  };

  return (
    <ResponsiveContainer width="100%"
      height={200}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomLabel}
          outerRadius={85}
          fill={theme.palette.primary.main}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`}
              fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip contentStyle={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.textSM.fontSize,
        }} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default RetailersByOnboardingStatus;